export default {
  agentTitle: '零售作业智能体',
  taskActions: '任务管理',
  workOrderPool: '订单列表',
  orderUnit: '单',
  orderManage: '订单管理',
  orderDetailTitle: '订单详情',
  orderManageTitle: '订单管理',
  viewMoreOrders: '查看更多',
  statusNew: '新接到',
  startReplenish: '一键启动补货',
  startTidy: '一键启动理货',
  startReset: '一键重置库存',
  cmdReplenish: '启动补货',
  cmdTidy: '启动理货',
  cmdReset: '一键重置',
  starting: '启动中…',
  resetting: '重置中…',
  replenishSuccess: '补货任务已创建并进入订单列表',
  tidySuccess: '理货任务已创建并进入订单列表',
  resetSuccess: '库存已重置',
  replenishApiPending: '补货接口暂未对接',
  tidyApiPending: '理货接口暂未对接',
  startFailed: '任务启动失败',
  statsTitle: '零售统计',
  statsScope: '今日',
  pickedCount: '售出商品',
  deliveredCount: '配送',
  salesAmount: '售货额',
  salesEstimated: '估价',
  activeOrders: '当前执行中订单',
  completedOrders: '已完成',
  pickupSuccessRate: '自主取货成功率',
  servicePeople: '服务人数',
  fastestDelivery: '最快送达时间',
  replenishToday: '补货',
  tidyToday: '理货',
  exceptionCount: '异常',
  viewExceptionList: '查看异常任务',
  exceptionListTitle: '异常任务',
  statViewHint: '查看',
  mileage: '累计自主行驶里程',
  peopleUnit: '人',
  salesChartTitle: '商品售卖',
  salesChartEmptyTitle: '暂无售出',
  salesChartEmptyHint: '有成交后将在此展示商品销量',
  topViewSwitch: '统计与摄像头切换',
  topViewStats: '统计',
  topViewCamera: '摄像头',
  sceneSwitch: '货架与地图切换',
  sceneShelf: '货架',
  sceneMap: '地图',
  mapTitle: '地图导航',
  mapLegendCurrent: '当前位置',
  mapLegendPath: '行驶轨迹',
  mapLegendStation: '点位',
  mapLegendTarget: '目标点位',
  mapLoadingTitle: '正在加载地图',
  mapLoadingHint: '正在获取设备栅格地图数据…',
  statusTitle: '本体状态',
  statusNoData: '暂无数据',
  statusSn: 'SN：',
  snSwitch: '切换设备 SN',
  snSwitchPlaceholder: '选择设备 SN',
  statusSelfCheck: '自检状态：',
  statusInTask: '是否在任务中：',
  statusReady: '就绪',
  statusNotReady: '未就绪',
  statusYes: '是',
  statusNo: '否',
  statusBattery: '剩余电量',
  statusCharging: '充电中',
  statusNotCharging: '未充电',
  statusVoltage: '电压',
  statusBatteryTemp: '电池温度',
  statusCycle: '循环',
  statusTelemetry: '遥测',
  statusHostTemp: '边缘主机温度',
  statusForwardSpeed: '前进速度',
  statusChassis: '底盘状态',
  statusRuntime: '采集组件运行时长',
  statusMotion: '运动反馈',
  statusStrafeSpeed: '横移速度',
  statusAngularSpeed: '角速度',
  statusControllerStopped: '控制器已停止',
  statusNav: '导航状态',
  statusNavPhase: '导航阶段',
  statusTargetStation: '目标站点',
  statusPose: '当前位姿',
  statusYaw: '朝向',
  statusMove: '移动控制',
  statusExpand: '展开',
  statusCollapse: '收起',
  statusForward: '前进',
  statusBackward: '后退',
  statusLeft: '左移',
  statusRight: '右移',
  statusEstop: '急停',
  statusMoving: '正在{dir}...',
  statusMoveDisabledHint: '方向控制已禁用，可使用急停',
  statusMoveHint: '按住方向键移动，松开停止',
  statusMoveFailed: '移动控制失败',
  statusEstopSent: '急停指令已发送',
  statusEstopFailed: '急停失败',
  statusChassisIdle: '已停止',
  statusChassisMoving: '移动中',
  statusChassisBlocked: '遇障阻挡',
  statusChassisEmergency: '急停',
  statusChassisError: '故障',
  statusNavIdle: '无导航',
  statusNavPending: '等待执行',
  statusNavActive: '导航中',
  statusNavPaused: '已暂停',
  statusNavSucceeded: '已到站',
  statusNavFailed: '导航失败',
  statusNavCancelled: '已取消',
  replenishCount: '补货次数',
  tidyCount: '理货次数',
  viewReplenishList: '查看补货列表',
  viewTidyList: '查看理货列表',
  replenishListTitle: '补货列表',
  tidyListTitle: '理货列表',
  categoryCompleteness: '品类齐全度',
  orderProgress: '订单履约',
  itemsUnit: '件',
  timesUnit: '次',
  skuShortageTitle: 'SKU 不足预警',
  skuAdviceTitle: '补货建议',
  viewReport: '任务可追溯报告',
  reportTitle: '任务可追溯报告',
  reportFilterAll: '全部订单',
  reportFilterStatusAll: '全部状态',
  reportFilterDate: '选择下单日期',
  reportSearchPlaceholder: '搜索单号 / 商品 / 路径',
  reportResultCount: '共 {n} 条',
  reportTotalCount: '全部 {n} 条',
  reportEmpty: '暂无任务记录',
  reportOrderProducts: '商品',
  reportOrderQty: '数量',
  reportOrderRoute: '路径',
  reportProgress: '进度',
  reportCreatedAt: '下单时间',
  reportExpand: '展开详情',
  reportCollapse: '收起',
  reportImages: '现场图片',
  reportImagesEmpty: '暂无图片，接入后将在此展示',
  reportAgentEvents: '执行过程',
  reportNoEvents: '暂无执行记录',
  statusPending: '排队中',
  statusInProgress: '进行中',
  statusCompleted: '已完成',
  statusAbnormal: '异常完成',
  orderTypePick: '拣货',
  orderTypeReplenish: '补货',
  orderTypeTidy: '理货',
  taskTitleReplenish: '补货任务',
  taskTitleTidy: '理货任务',
  agentLive: '推理中',
  agentLatest: '最新',
  agentEmpty: '等待零售作业推理事件…',
  agentNextStep: '下一步：',
  reportCurrentAisle: '当前货位',
  shelfTitle: '货架陈列',
  shelfDaily: '日用品',
  shelfBeverage: '饮料',
  shelfSnack: '零食',
  shelfLoading: '商品加载中…',
  shelfNoImage: '暂无图片',
  shelfInventory: '库存',
}
